import { useEffect, useRef } from 'react';

export function useScript(
  id: string,
  textContent: string,
  tag: 'head' | 'body' = 'head',
  isActive: boolean = true
) {
  const initialized = useRef(false);

  useEffect(() => {
    // As soon as it becomes active, the script loads and stays loaded.
    if (initialized.current || !isActive) {
      return;
    }
    initialized.current = true;

    const script = document.createElement('script');
    script.textContent = textContent;
    script.async = true;
    script.id = id;
    document[tag].appendChild(script);
  }, [isActive, textContent, id, tag]);
}
